{
  "errors.push.environment_mismatch": "The push configuration does not match this service's runtime environment. Switch environments before retrying.",
  "errors.push.config_inactive": "The push channel is not active. Check its status before retrying.",
  "errors.push.credentials_unavailable": "The credential encryption service is unavailable. Ask an administrator to check the service configuration.",
  "errors.common.conflict": "The data has changed. Refresh and try again.",
  "errors.common.forbidden": "You do not have permission to perform this action.",
  "errors.common.network": "Network connection failed. Check your connection and try again.",
  "errors.common.not_found": "The requested resource was not found.",
  "errors.common.timeout": "The request timed out. Try again.",
  "errors.common.unauthorized": "Your session has expired. Sign in again.",
  "errors.common.unknown": "An unknown error occurred. Try again later.",
  "errors.iam.user.last_admin": "The last administrator of this tenant cannot be disabled.",
  "errors.iam.user.org_invalid": "A selected department or position is missing, disabled, or belongs to another tenant.",
  "errors.iam.user.role_invalid": "A selected role is missing, disabled, or belongs to another tenant.",
  "errors.org.position.code_conflict": "The position code is already in use.",
  "errors.org.position.not_found": "The position was not found.",
  "errors.org.position.occupied": "The position still has assigned members and cannot be deleted.",
  "errors.org.unit.code_conflict": "The department code is already in use.",
  "errors.org.unit.cycle": "A department cannot be moved beneath itself or one of its descendants.",
  "errors.org.unit.not_found": "The department was not found.",
  "errors.org.unit.occupied": "The department still has children or members and cannot be deleted.",
  "errors.ai.quota": "AI budget or concurrency limit exceeded.",
  "errors.ai.unsupported": "The model does not support this capability.",
  "errors.ai.unavailable": "The model service is temporarily unavailable."
}
